/**
 * @fileoverview AspectRatio - Maintain aspect ratio utility component
 *
 * Purpose: Maintain consistent aspect ratios for images and media
 * Dependencies: Radix UI AspectRatio primitive
 * Used by: Image displays, video embeds, media cards
 *
 * Features:
 * - Maintains aspect ratio across responsive sizes
 * - Prevents layout shift
 * - Common ratios: 16/9, 4/3, 1/1, 21/9
 * - Accessible
 *
 * @example
 * <AspectRatio ratio={16 / 9}>
 *   <img
 *     src="/placeholder.jpg"
 *     alt="Image"
 *     className="rounded-md object-cover"
 *   />
 * </AspectRatio>
 *
 * @example
 * // Square aspect ratio
 * <AspectRatio ratio={1}>
 *   <img src="/avatar.jpg" alt="Avatar" />
 * </AspectRatio>
 */

import * as AspectRatioPrimitive from "@radix-ui/react-aspect-ratio";

const AspectRatio = AspectRatioPrimitive.Root;

export { AspectRatio };
